import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {NotificationTypeEnum} from '../../interfaces/NotificationTypeEnum';
import {Store} from '@ngxs/store';
import {ClearAllNotifications, LoadMoreNotifications} from '../../states/profile/profile.actions';

@Component({
  selector: 'app-notifications-dropdown',
  templateUrl: './notifications-dropdown.component.html',
  styleUrls: ['./notifications-dropdown.component.scss'],
})
export class NotificationsDropdownComponent {
  @Input() notifications$: Observable<any>;

  @Output() linkSelected: EventEmitter<void> = new EventEmitter();

  NotificationTypeEnum = NotificationTypeEnum;

  constructor(
    private store: Store,
  ) {
  }

  loadMore(): void {
    this.store.dispatch(new LoadMoreNotifications());
  }

  clearAll(): void {
    this.store.dispatch(new ClearAllNotifications());
  }
}
